export const ENDPOINT_REQUEST = 'ENDPOINT_REQUEST'
export const ENDPOINT_SUCCESS = 'ENDPOINT_SUCCESS'
export const ENDPOINT_FALIURE = 'ENDPOINT_FALIURE'
export const CHECK_SUBDOMAIN_REQUEST = 'CHECK_SUBDOMAIN_REQUEST'
export const CHECK_SUBDOMAIN_SUCCESS = 'CHECK_SUBDOMAIN_SUCCESS'
export const CHECK_SUBDOMAIN_FALIURE = 'CHECK_SUBDOMAIN_FALIURE'
export const ADD_SUBDOMAIN_REQUEST = 'ADD_SUBDOMAIN_REQUEST'
export const ADD_SUBDOMAIN_SUCCESS = 'ADD_SUBDOMAIN_SUCCESS'
export const ADD_SUBDOMAIN_FALIURE = 'ADD_SUBDOMAIN_FALIURE'
